import React, { useEffect } from "react"
import linkbrokenlogo from "../../../../../assets/images/lystfacelogos/verified.svg"
import BackgroundHelper from "../../../Common/BackgroundHelper"
import SupportLayoutHelper from "../../../Common/SupportLayoutHelper"
import PasswordUpdated from "./PasswordUpdated"
import withRouter from "../../../../Common/withRouter"

const PasswordUpdatedBg = (props) => {

  useEffect(() => {
    if (props?.isPasswordUpdated) {
      setTimeout(() => {
        props.router.navigate("/login")
      }, 3000);
    }

  }, [props?.isPasswordUpdated])

  return (
    <>
      <BackgroundHelper
        layout={
          <SupportLayoutHelper
            imgsrc={linkbrokenlogo}
            title={"Password Updated Successfully!"}
            layout={<PasswordUpdated />}
          />
        }
      />
    </>
  )
}

export default withRouter(PasswordUpdatedBg)
